var map = {
	"./体检01.png": 2487,
	"./体检02.png": 2488,
	"./体检03.png": 2489,
	"./体检04.png": 2490,
	"./体检05.png": 2491,
	"./体检默认.png": 2492,
	"./卡01.png": 2493,
	"./卡02.png": 2494,
	"./卡03.png": 2495,
	"./卡04.png": 2496,
	"./卡05.png": 2497,
	"./卡默认.png": 2498,
	"./宿舍01.png": 2499,
	"./宿舍02.png": 2500,
	"./宿舍03.png": 2501,
	"./宿舍04.png": 2502,
	"./宿舍05.png": 2503,
	"./宿舍默认.png": 2504,
	"./打印01.png": 2505,
	"./打印02.png": 2506,
	"./打印03.png": 2507,
	"./打印04.png": 2508,
	"./打印05.png": 2509,
	"./打印默认.png": 2510,
	"./报到01.png": 2511,
	"./报到02.png": 2512,
	"./报到03.png": 2513,
	"./报到04.png": 2514,
	"./报到05.png": 2515,
	"./报到默认.png": 2516,
	"./校服01.png": 2517,
	"./校服02.png": 2518,
	"./校服03.png": 2519,
	"./校服04.png": 2520,
	"./校服05.png": 2521,
	"./校服默认.png": 2522,
	"./缴费01.png": 2523,
	"./缴费02.png": 2524,
	"./缴费03.png": 2525,
	"./缴费04.png": 2526,
	"./缴费05.png": 2527,
	"./缴费默认.png": 2528,
	"./通用01.png": 2529,
	"./通用02.png": 2530,
	"./通道01.png": 2531,
	"./通道02.png": 2532,
	"./通道03.png": 2533,
	"./通道04.png": 2534,
	"./通道05.png": 2535,
	"./通道默认.png": 2536
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2579;


//////////////////
// WEBPACK FOOTER
// ./styles/images/user/normal (\.gif|\.jpeg|\.png|\.jpg|\.bmp)
// module id = 2579
// module chunks = 0